module.exports = __webpack_public_path__ + "static/media/Finnovex-Saudi-2025.56b10a83.png";